module.exports = __webpack_public_path__ + "img/icon-protrain-8.fef55b25.png";